import api from './api';

// The practice's medicines and consumables by NAPPI code — see backend nappiController.
const nappiService = {
  // q: words or the start of a code; type: medicine | consumable; all: include inactive (admin)
  list: ({ q, type, all } = {}) =>
    api.get('/nappi', { params: { q: q || undefined, type: type || undefined, all: all ? 1 : undefined } }).then((r) => r.data.items || []),
  create: (item) => api.post('/nappi', item).then((r) => r.data.item),
  update: (id, item) => api.put(`/nappi/${id}`, item).then((r) => r.data.item),
};

export default nappiService;
